import { Components } from 'src/components';
import { setComponentAttributes, createStoryWrapper } from 'shared/storybook-utils';

export default {
  title: 'Components/Button',
  component: 'a1-button',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Content Component - Primary UI component for user interaction.',
      },
    },
    layout: 'centered',
  },
  decorators: [createStoryWrapper({ height: 60 })],
};

const elementName = 'a1-button';

const Template = (args: Components.A1Button): HTMLA1ButtonElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Default: Story<Components.A1Button> = Template.bind({});
Default.args = {
  text: 'Primary Button',
};

export const Inverse: Story<Components.A1Button> = Template.bind({});
Inverse.args = {
  text: 'Primary Button',
  inverse: true,
};
Inverse.parameters = {
  backgrounds: {
    default: 'Inverse',
  },
};

export const Secondary: Story<Components.A1Button> = Template.bind({});
Secondary.args = {
  ...Default.args,
  text: 'Secondary Button',
  type: 'secondary',
};

export const Tertiary: Story<Components.A1Button> = Template.bind({});
Tertiary.args = {
  ...Default.args,
  text: 'Tertiary Button',
  type: 'tertiary',
};

export const Critical: Story<Components.A1Button> = Template.bind({});
Critical.args = {
  ...Default.args,
  text: 'Critical Button',
  critical: true,
};

export const Plain: Story<Components.A1Button> = Template.bind({});
Plain.args = {
  ...Default.args,
  text: 'Plain Button',
  kind: 'plain',
};

export const Small: Story<Components.A1Button> = Template.bind({});
Small.args = {
  ...Default.args,
  text: 'Small Button',
  size: 's',
};

export const FullWidth: Story<Components.A1Button> = Template.bind({});
FullWidth.args = {
  ...Default.args,
  text: 'Full-Width Button',
  fullWidth: true,
};

export const IconBefore: Story<Components.A1Button> = Template.bind({});
IconBefore.args = {
  ...Default.args,
  text: 'Button Icon Before',
  iconPosition: 'before',
};

export const IconAfter: Story<Components.A1Button> = Template.bind({});
IconAfter.args = {
  ...Default.args,
  text: 'Button Icon After',
  iconPosition: 'after',
};

export const IconOnly: Story<Components.A1Button> = Template.bind({});
IconOnly.args = {
  ...Default.args,
  text: '',
};

export const IconOnlyIndicator: Story<Components.A1Button> = Template.bind({});
IconOnlyIndicator.args = {
  ...IconOnly.args,
  type: 'tertiary',
  indicatorType: 'indicator',
};

export const IconOnlyIndicatorCounter: Story<Components.A1Button> = Template.bind({});
IconOnlyIndicatorCounter.args = {
  ...IconOnlyIndicator.args,
  indicatorType: 'indicator-count',
  indicatorCounter: 123,
};
